import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO nâng cao khả năng di chuyển hàng không và đảm bảo an toàn cho các chuyến bay cũng như hoạt động vận hành thông qua việc theo dõi máy bay theo thời gian thực và cung cấp thông tin vận hành. Thông qua việc cung cấp thông tin hãng hàng không, giám sát đường bay, kiểm tra lịch trình tại từng sân bay, quản lý tình huống khẩn cấp, cải thiện dịch vụ khách hàng, và giám sát tác động môi trường, ORBRO đang cải thiện trải nghiệm tổng thể của các chuyến bay.',
  keywords: 'Bản sao số, máy bay, thành phố số, thực tế ảo, ban sao so, may bay, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Kết nối thông tin máy bay',
  title: 'Digital Twin - Kết nối thông tin máy bay',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-airplane',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Maybay',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Kết nối thông tin máy bay',
      subHead: '',
      desc: 'ORBRO nâng cao khả năng di chuyển hàng không và đảm bảo an toàn cho các chuyến bay cũng như hoạt động vận hành thông qua việc theo dõi máy bay theo thời gian thực và cung cấp thông tin vận hành. Thông qua việc cung cấp thông tin hãng hàng không, giám sát đường bay, kiểm tra lịch trình tại từng sân bay, quản lý tình huống khẩn cấp, cải thiện dịch vụ khách hàng, và giám sát tác động môi trường, ORBRO đang cải thiện trải nghiệm tổng thể của các chuyến bay.\nViệc cung cấp thông tin hãng hàng không giúp hành khách lên kế hoạch cho chuyến bay một cách thuận tiện bằng cách cung cấp những thông tin thiết yếu. Giám sát đường bay đảm bảo an toàn và quản lý giao thông hàng không, hỗ trợ vận hành thông suốt. Việc cung cấp lịch trình tại từng sân bay giúp du khách quản lý hiệu quả lịch trình chuyến đi bằng cách cung cấp thông tin du lịch chính xác và đáng tin cậy.\nQuản lý tình huống khẩn cấp ưu tiên hàng đầu sự an toàn của hành khách và nhân viên để đối phó với các tình huống bất ngờ. Cải thiện dịch vụ khách hàng giúp nâng cao chất lượng dịch vụ và khả năng đáp ứng yêu cầu của hành khách, từ đó tăng mức độ hài lòng. Giám sát tác động môi trường giúp thiết lập các chiến lược vận hành hàng không bền vững nhằm hoàn thành trách nhiệm với môi trường và theo đuổi sự bền vững. ORBRO hỗ trợ các chuyến bay an toàn và thuận tiện thông qua những chức năng đa dạng này, đồng thời đóng góp vào hoạt động vận hành bền vững.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cung cấp thông tin hãng hàng không',
      desc: 'ORBRO cung cấp thông tin theo thời gian thực như loại máy bay, đường bay, lịch trình, v.v., của từng hãng hàng không. Thông tin này cần thiết để hành khách lập kế hoạch cho chuyến bay, đồng thời cung cấp dữ liệu quan trọng cho các hãng hàng không và nhà khai thác sân bay trong việc vận hành và quản lý máy bay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát đường bay',
      desc: 'ORBRO giám sát và hiển thị đường bay theo thời gian thực của máy bay, đóng vai trò quan trọng trong việc đảm bảo quản lý giao thông hàng không và an toàn bay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cung cấp lịch bay theo từng sân bay',
      desc: 'ORBRO cung cấp lịch bay tại từng sân bay, bao gồm lịch trình đến và đi, thông tin cổng ra máy bay, v.v., cho mỗi sân bay, nhằm cung cấp thông tin du lịch chính xác cho hành khách và nâng cao hiệu quả vận hành sân bay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý tình huống khẩn cấp',
      desc: 'ORBRO sử dụng dữ liệu hàng không theo thời gian thực để cho phép ứng phó và quản lý nhanh chóng các tình huống khẩn cấp, đảm bảo an toàn cho hành khách và nhân viên, đồng thời giảm thiểu các rủi ro tiềm ẩn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện dịch vụ khách hàng',
      desc: 'ORBRO sử dụng thông tin hàng không theo thời gian thực để thúc đẩy việc cải thiện dịch vụ và khả năng đáp ứng yêu cầu của hành khách, nâng cao sự hài lòng của hành khách và cải thiện trải nghiệm bay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát tác động môi trường',
      desc: 'ORBRO giám sát các tác động môi trường liên quan đến hoạt động của máy bay và thiết lập các chiến lược vận hành hàng không bền vững, đóng vai trò quan trọng trong nỗ lực giảm phát thải carbon và bảo vệ môi trường.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
